module.exports = __webpack_public_path__ + "static/media/Slice7@2x.578c127b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice7@2x.png
// module id = 1412
// module chunks = 0